import { MrfiktivHttpClientProvider } from "@/services/mrfiktiv/mrfiktiv-http-client.provider";
import { MrfiktivCreateDocumentRuleDtoGen, MrfiktivDocumentRuleControllerGetParamsGen } from "../v1/data-contracts";
import { DocumentRule } from "../v1/DocumentRule";

/**
 * Communicate with documentRule API
 */
class DocumentRuleService {
  mrfiktivProxy: DocumentRule;

  /**
   * Construct service
   */
  constructor(mrfiktivHttpClientProvider: MrfiktivHttpClientProvider) {
    this.mrfiktivProxy = new DocumentRule(mrfiktivHttpClientProvider.client());
  }

  /**
   * Create an documentRule
   */
  async create(partnerId: string, data: MrfiktivCreateDocumentRuleDtoGen) {
    const documentRule = (await this.mrfiktivProxy.documentRuleControllerCreate(partnerId, data)).data;

    return documentRule;
  }

  /**
   * Get all documentRule
   */
  async get(data: MrfiktivDocumentRuleControllerGetParamsGen) {
    const documentRules = (await this.mrfiktivProxy.documentRuleControllerGet(data)).data;

    return documentRules;
  }

  /**
   * Get a documentRule
   */
  async getOne(partnerId: string, documentRuleId: string) {
    const documentRule = (await this.mrfiktivProxy.documentRuleControllerGetOne(partnerId, documentRuleId)).data;

    return documentRule;
  }

  /**
   * Update a documentRule
   */
  async update(partnerId: string, documentRuleId: string, data: MrfiktivCreateDocumentRuleDtoGen) {
    const documentRule = (await this.mrfiktivProxy.documentRuleControllerUpdate(partnerId, documentRuleId, data)).data;

    return documentRule;
  }

  /**
   * Delete a documentRule
   */
  async delete(partnerId: string, documentRuleId: string) {
    const documentRule = (await this.mrfiktivProxy.documentRuleControllerDelete(partnerId, documentRuleId)).data;

    return documentRule;
  }
}

/**
 * Communicate with documentRule API
 */
export default new DocumentRuleService(new MrfiktivHttpClientProvider());
